import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const STEPS = [
  { id: "01", title: "MONITOR", desc: "Competitors, platforms, messaging and market movement." },
  { id: "02", title: "ANALYSE", desc: "Identify patterns, gaps and emerging opportunities." },
  { id: "03", title: "INTERPRET", desc: "Explain what signals mean for your market position." },
  { id: "04", title: "RECOMMEND", desc: "Prioritise clear strategic and creative actions." },
  { id: "05", title: "EXECUTE", desc: "Support campaigns, content and digital implementation." }
];

export default function Process() {
  const [hovered, setHovered] = useState(null);

  return (
    <section className="py-40 bg-zinc-950 border-y border-zinc-900 min-h-[600px] max-h-[800px] flex flex-col justify-center">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 w-full text-center">
        <h2 className="text-4xl md:text-6xl font-serif font-bold text-white mb-24">Intelligence that leads to action.</h2>

        {/* Desktop View */}
        <div className="hidden md:flex items-center justify-between relative">
          <div className="absolute top-1/2 left-0 w-full h-px bg-zinc-900 -translate-y-1/2 z-0"></div>
          {STEPS.map((step, i) => (
            <div 
              key={step.id} 
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              className="relative z-10 flex flex-col items-center group cursor-default"
            >
              <div className={`w-4 h-4 rounded-full border-2 transition-all duration-500 mb-6 ${
                hovered === i ? 'bg-blue-600 border-blue-600 scale-125' : 'bg-black border-zinc-800'
              }`}></div>
              <h3 className="text-xs font-bold tracking-[0.3em] text-white uppercase mb-4">{step.title}</h3>
              
              <AnimatePresence>
                {hovered === i && (
                  <motion.p
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 10 }}
                    className="absolute top-full mt-4 w-48 text-[11px] text-zinc-500 leading-relaxed font-medium"
                  >
                    {step.desc}
                  </motion.p>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>

        {/* Mobile View */}
        <div className="md:hidden space-y-12 text-left">
          {STEPS.map((step) => (
            <div key={step.id} className="flex gap-8">
              <span className="text-blue-600 font-bold text-xs tracking-widest">{step.id}</span>
              <div>
                <h3 className="text-xs font-bold tracking-[0.3em] text-white uppercase mb-2">{step.title}</h3>
                <p className="text-xs text-zinc-500 leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}